import { render, staticRenderFns } from "./ModalStudentEdit.vue?vue&type=template&id=0d6e916f&scoped=true&lang=pug"
import script from "./ModalStudentEdit.vue?vue&type=script&lang=ts"
export * from "./ModalStudentEdit.vue?vue&type=script&lang=ts"
import style0 from "./ModalStudentEdit.vue?vue&type=style&index=0&id=0d6e916f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e916f",
  null
  
)

export default component.exports